import { render, staticRenderFns } from "./JsonEditorDialog.vue?vue&type=template&id=63d23e26&scoped=true"
import script from "./JsonEditorDialog.vue?vue&type=script&lang=js"
export * from "./JsonEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./JsonEditorDialog.vue?vue&type=style&index=0&id=63d23e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d23e26",
  null
  
)

export default component.exports